export const catEstatusCatEstatusDevolucion = Object.freeze({
    EN_ESPERA: 1,
    VALIDADA: 2,
    APROBADA: 3,
    RECHAZADA: 4,
    RECHAZADA_FINANZAS: 5,
    EN_PROCESO: 6,
})